const language = {
	'en': {
		'myProfile': 'My profile',
		'myTeam': 'My team',
		'company': 'Company',
		'firstName': 'First name',
		'lastName': 'Surname',
		'jobTitle': 'Job title',
		'email': 'E-mail',
		'phone': 'Phone',
		'contactInformation': 'Contact information',
		'password': 'Password',
		'currentPassword': 'Current password',
		'newPassword': 'New password',
		'repeatPassword': 'Repeat password',
		'save': 'Save',
		'changePassword': 'Change password',
		'addUser': 'Add user',
		'deleteUser': 'Delete user',
		'deleteUserConfirmation': 'Are you sure you want to delete the user\'s account?',
		'add': 'Add',
		'edit': 'Edit',
		'delete': 'Delete',
		'cancel': 'Cancel',
	},
	'pl': {
		'myProfile': 'Mój profil',
		'myTeam': 'Mój zespół',
		'company': 'Firma',
		'firstName': 'Imię',
		'lastName': 'Nazwisko',
		'jobTitle': 'Stanowisko',
		'email': 'E-mail',
		'phone': 'Telefon',
		'contactInformation': 'Informacje kontaktowe',
		'password': 'Hasło',
		'currentPassword': 'Obecne hasło',
		'newPassword': 'Nowe hasło',
		'repeatPassword': 'Powtórz hasło',
		'save': 'Zapisz',
		'changePassword': 'Zmień hasło',
		'addUser': 'Dodaj użytkownika',
		'deleteUser': 'Usuń użytkownika',
		'deleteUserConfirmation': 'Jesteś pewien, że chcesz usunąć użytkownika?',
		'add': 'Dodaj',
		'edit': 'Edytuj',
		'delete': 'Usuń',
		'cancel': 'Anuluj',
	}
}

export default language


// WEBPACK FOOTER //
// ./src/utils/lang/user.js